module.exports = __webpack_public_path__ + "img/icon-storage-add-disabled.e92355a4.svg";